var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-eoc"},[_c('riseup-button',{staticClass:"share-button",attrs:{"title":"שיתוף עם חברים","variant":'secondary',"action":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }